<template>

  <div class="position-fixed bottom-0 start-50 translate-middle-x p-3"
       style="z-index: 1199">
    <div :id="mainId"
         class="toast"
         role="alert"
         aria-live="assertive"
         aria-atomic="true">
      <div class="toast-header">
        <strong class="me-auto">
          {{ title }} <span>{{ titleSpanContent }}</span>
        </strong>
        <button type="button"
                class="btn-close"
                data-bs-dismiss="toast"
                aria-label="Close"></button>
      </div>
      <div class="toast-body">
        <p v-for="message of messages">
          {{ message }}
        </p>
      </div>
    </div>
  </div>

</template>

<script>

import {Toast} from "bootstrap";

export default {
  name: 'ToastNotification',
  expose: ['displayToast'],
  components: {},
  props: {
    mainId: String
  },
  data()
  {
    return {
      title: '',
      titleSpanContent: '',
      messages: [],
      lastToast: null,
      toastElement: null
    }
  },
  mounted()
  {
    this.toastElement = document.getElementById(this.mainId);
  },
  methods: {
    displayToast: function (title = null, titleSpanContent = null, messages = null, delayMilliseconds = 4096)
    {
      if (!title)
      {
        title = 'Success';
      }

      if (!titleSpanContent)
      {
        titleSpanContent = '✔️';
      }

      if (!messages || messages.length === 0)
      {
        messages = ['Action has been performed successfully.'];
      }

      if (delayMilliseconds < 256)
      {
        delayMilliseconds = 256;
      }

      this.title = title;
      this.titleSpanContent = titleSpanContent;

      this.messages = messages;

      if (this.lastToast)
      {
        this.lastToast.dispose();
      }

      this.lastToast = new Toast(this.toastElement, {delay: delayMilliseconds});
      this.lastToast.show();
    }
  }
}
</script>


<style scoped>

.toast-body {
  gap: 8px;
  display: flex;
  flex-direction: column;
}

.toast-body > p {
  margin: 0;
}

</style>